<template>
  <div class="modal-layout justify-content-center align-content-center">
    <main class="pt-0 h-100">
      <div class="container-fluid">
        <div class="row vh-100">
          <div class="d-none d-lg-flex col-lg-8 mx-auto bg-col align-items-center"></div>
          <div class="col bg-white d-flex align-items-center px-sm-0 position-relative">
            <AwlModalCard class="mb-lg-5 my-5 my-sm-none position-absolute" :title="title" box-shadow>
              <router-view @title="updateTitle" class="flex-grow-1" />
            </AwlModalCard>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  components: {
    AwlModalCard: () => import('../../../components/Layout/Card/AwlModalCard'),
  },
  data () {
    return {
      title: 'RFF',
    };
  },
  methods: {
    updateTitle (title) {
      this.title = title;
    },
  },
};
</script>

<style lang="scss">

$primary: blue !default;

.modal-layout {
  .bg-col {
    background: url($path-images + '/signup-background-space.jpeg') no-repeat center center;
    background-size: cover;
    position: relative;

    &::after {
      background: rgba($black, .15);
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    > * {
      position: relative;
      z-index: 1;
    }
  }

  .awl-card {
    left: 50%;
    max-width: 500px;
    margin:auto;
    transform: translateX(-50%);
    &--content {
      padding: 0 20px;
    }
    @include media-breakpoint-up(lg) {
      left: 0;
      transform: translateX(-33%);
    }
  }
}

</style>
